import { render, staticRenderFns } from "./productListSecond.vue?vue&type=template&id=7fa303ee&scoped=true"
import script from "./productListSecond.vue?vue&type=script&lang=js"
export * from "./productListSecond.vue?vue&type=script&lang=js"
import style0 from "./productListSecond.vue?vue&type=style&index=0&id=7fa303ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa303ee",
  null
  
)

export default component.exports